var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSignature({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signature applied"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    transform: "translate(-28 -705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fields options"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277493"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: -15.5,
    width: 111,
    height: 47,
    rx: 11.5,
    stroke: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_3188004"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E9E8ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi_8392506",
    clipPath: "url(#clip0_986_1361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.46875 4.95416C0.727625 4.95416 0.9375 4.74428 0.9375 4.48541V0.9375H4.48541C4.74428 0.9375 4.95416 0.727625 4.95416 0.46875C4.95416 0.209875 4.74428 0 4.48541 0H0.46875C0.209875 0 0 0.209875 0 0.46875V4.48541C0 4.74428 0.209875 4.95416 0.46875 4.95416Z",
    fill: "#1E1341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.48541 15.0626H0.9375V11.5146C0.9375 11.2558 0.727625 11.0459 0.46875 11.0459C0.209875 11.0459 0 11.2558 0 11.5146V15.5313C0 15.7902 0.209875 16.0001 0.46875 16.0001H4.48541C4.74428 16.0001 4.95416 15.7902 4.95416 15.5313C4.95416 15.2724 4.74428 15.0626 4.48541 15.0626Z",
    fill: "#1E1341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5313 0H11.5146C11.2558 0 11.0459 0.209875 11.0459 0.46875C11.0459 0.727625 11.2558 0.9375 11.5146 0.9375H15.0626V4.48541C15.0626 4.74428 15.2724 4.95416 15.5313 4.95416C15.7902 4.95416 16.0001 4.74428 16.0001 4.48541V0.46875C16.0001 0.209875 15.7902 0 15.5313 0Z",
    fill: "#1E1341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.5313 11.0459C15.2724 11.0459 15.0626 11.2558 15.0626 11.5146V15.0626H11.5146C11.2558 15.0626 11.0459 15.2724 11.0459 15.5313C11.0459 15.7902 11.2558 16.0001 11.5146 16.0001H15.5313C15.7902 16.0001 16.0001 15.7902 16.0001 15.5313V11.5146C16.0001 11.2558 15.7902 11.0459 15.5313 11.0459Z",
    fill: "#1E1341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.5317 6.52708C12.4239 6.52708 10.6946 9.03752 10.0088 9.03752C9.73277 9.03752 9.88121 8.36239 9.95146 8.14823C10.0525 7.84495 9.82646 7.53127 9.50677 7.53127C9.08264 7.53127 8.75586 7.91411 8.30358 8.44395C7.93118 8.88026 7.36839 9.53961 6.99633 9.53961C6.3918 9.53961 7.24068 7.55764 7.41558 7.20548C7.48824 7.0602 7.48049 6.88761 7.39508 6.74942C7.30968 6.6112 7.15877 6.52711 6.99633 6.52711C6.53799 6.52711 6.24218 7.00195 5.18355 8.81745C4.76489 9.53548 4.29033 10.3493 3.85893 10.9869C3.38521 11.687 3.12574 11.9301 3.01118 12.0133C2.88458 11.6571 2.90305 10.5173 3.53455 8.36989C4.07368 6.53658 4.84102 4.7933 5.31943 4.31483C5.50249 4.13177 5.50249 3.83498 5.31943 3.65192C5.13639 3.46889 4.83958 3.46889 4.65652 3.65192C3.95436 4.35408 3.1693 6.3547 2.71039 7.85455C1.7318 11.0525 1.74514 12.9875 2.97964 12.9875C3.73161 12.9875 4.48558 11.8668 5.87564 9.4913C5.96708 10.1545 6.42721 10.4771 6.9963 10.4771C7.76868 10.4771 8.42096 9.74898 8.95121 9.12917C9.00068 9.35298 9.20536 9.97502 10.0088 9.97502C11.316 9.97502 12.625 7.46458 15.5317 7.46458C15.7906 7.46458 16.0005 7.2547 16.0005 6.99583C16.0005 6.73695 15.7906 6.52708 15.5317 6.52708Z",
    fill: "#1E1341"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSignature);
export default __webpack_public_path__ + "static/media/MobileSignature.ad30655960d6600676eba161e95e0833.svg";
export { ForwardRef as ReactComponent };